import { createContext } from 'react';

export interface FullscreenGalleryContextType {
  isGalleryFullscreen: boolean;
  setIsGalleryFullscreen: (isFullscreen: boolean) => void;
  isLogoLightboxOpen: boolean;
  setIsLogoLightboxOpen: (isOpen: boolean) => void;
}

export const FullscreenGalleryContext = createContext<FullscreenGalleryContextType | undefined>(
  undefined
);
